(() => {
  const menus = [...document.querySelectorAll('[data-ops22-menu]')];
  if (!menus.length) return;

  const makeGrid = document.querySelector('.ops22-header__make-illustrated');
  if (makeGrid) {
    const productTiles = [
      { handle: 'custom-lumi-edge-rgb-display-counter', title: 'Illuminated Displays' },
      { handle: 'everyday-roller-banner-stand', title: 'Roller Banners' },
    ];
    const shopRoot = (window.Shopify?.routes?.root || '/').replace(/\/+$/, '');

    productTiles.forEach(({ handle, title }) => {
      if (makeGrid.querySelector(`[data-ops22-product-tile="${handle}"]`)) return;

      const productUrl = `${shopRoot}/products/${handle}`;
      const item = document.createElement('a');
      item.className = 'ops22-header__make-illustrated-item';
      item.href = productUrl;
      item.dataset.ops22ProductTile = handle;

      const media = document.createElement('span');
      media.className = 'ops22-header__make-illustrated-media';

      const label = document.createElement('span');
      label.className = 'ops22-header__make-illustrated-title';
      label.textContent = title;

      item.append(media, label);
      makeGrid.append(item);

      fetch(`${productUrl}.js`, { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((product) => {
          if (!product) return;
          const featuredImage = product.featured_image;
          const fallbackImage = product.images?.[0];
          const imageUrl =
            (typeof featuredImage === 'string' ? featuredImage : featuredImage?.src) ||
            (typeof fallbackImage === 'string' ? fallbackImage : fallbackImage?.src);
          if (!imageUrl) return;

          const optimizedUrl = new URL(imageUrl, window.location.origin);
          optimizedUrl.searchParams.set('width', '360');

          const image = document.createElement('img');
          image.src = optimizedUrl.toString();
          image.alt = title;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.sizes = '180px';
          media.append(image);
        })
        .catch(() => {});
    });
  }

  const closeMenu = (menu, restoreFocus = false) => {
    if (!menu?.open) return;
    menu.removeAttribute('open');
    if (restoreFocus) menu.querySelector(':scope > summary')?.focus();
  };

  menus.forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (!menu.open) return;
      menus.forEach((other) => {
        if (other !== menu && !menu.contains(other) && !other.contains(menu)) closeMenu(other);
      });
    });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => closeMenu(menu)));
  });

  document.addEventListener('click', (event) => {
    menus.forEach((menu) => {
      if (menu.open && !menu.contains(event.target)) closeMenu(menu);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = menus.find((menu) => menu.open);
    if (open) closeMenu(open, true);
  });
})();
